import React from 'react';
import { AppState } from 'services/types';
import { useSelector } from 'react-redux';
import { Field } from 'react-final-form';

import RenderEntityTable from 'forms/RenderEntityTable';
import { SchemaEntityTypeId } from 'services/schemas/types';
import { EntityId } from 'services/entities/types';
import { APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_NAMESPACE } from 'services/appliedFertilizerEntitiesByDate/constants';
import {
    makeSelectInnerEntitiesGroupedByVariety,
    makeSelectInnerEntityIds
} from './selectors';
import { FertilizerEntityOptions } from '../FertilizerSchemaInnerEntityOptions/types';

export interface Props {
    name: string;
    validate?: any;
    entityId?: EntityId;
    entityTypeId: SchemaEntityTypeId;
    options: FertilizerEntityOptions;
}

export default function FertilizerSchemaInnerEntityTableFieldRender(
    props: Props
): React.ReactElement | null {
    const { name, validate, entityTypeId, entityId } = props;

    const innerEntityIds = useSelector((state: AppState) =>
        makeSelectInnerEntityIds()(state, props)
    );
    const innerEntitiesGroupedByVariety = useSelector((state: AppState) =>
        makeSelectInnerEntitiesGroupedByVariety()(state, props)
    );

    return (
        <Field
            component={RenderEntityTable}
            subscription={{
                value: true,
                touched: true,
                error: true,
                submitFailed: true,
                dirtySinceLastSubmit: true,
                invalid: true
            }}
            name={name}
            validate={validate}
            entityTypeId={entityTypeId}
            entityId={entityId}
            innerEntityIds={innerEntityIds}
            innerEntitiesGroupedByVariety={innerEntitiesGroupedByVariety}
            namespace={APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_NAMESPACE}
        />
    );
}
